import { api } from '../utils'

export const getPlaces = (params: Record<string, any>) =>
  api.get(`/places`, params).then(res => res?.data)

export const getPlaceDetails = (placeId: string) =>
  api.get(`/places/${placeId}/details`).then(res => res?.data)
